import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const FilledDismiss: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_dismiss"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="dismiss icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 28 28"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M4.08489 4.10149C4.47541 3.71096 5.10857 3.71096 5.4991 4.10149L14.0001 12.6025L22.5012 4.10149C22.8917 3.71096 23.5249 3.71096 23.9154 4.10149C24.3059 4.49201 24.3059 5.12518 23.9154 5.5157L15.4143 14.0167L23.883 22.4854C24.2736 22.876 24.2736 23.5091 23.883 23.8996C23.4925 24.2902 22.8594 24.2902 22.4688 23.8996L14.0001 15.4309L5.53144 23.8996C5.14091 24.2902 4.50775 24.2902 4.11722 23.8996C3.7267 23.5091 3.7267 22.876 4.11722 22.4854L12.5859 14.0167L4.08489 5.5157C3.69436 5.12518 3.69436 4.49201 4.08489 4.10149Z" />
      </svg>
    </span>
  );
};

export { FilledDismiss };
